import type { ComparatorType } from 'advanced-filters/data/comparators';
import type { DataTypeType } from 'advanced-filters/data/dataTypes';
import { DATA_TYPE_TO_OPTIONS_MAP } from 'advanced-filters/data/dataTypeSpecificComparatorOptions';
import { pendingFilterSelector, selectedBaseConditionDataType } from 'advanced-filters/selectors/filter';
import { modifyPendingFilter } from 'advanced-filters/store/filter';
import { Select } from 'antd';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

/**
 * Renders Dropdown for Base Condition Comparator based on Condition Key
 */
export default function ConditionComparatorSelect() {
  const dispatch = useDispatch();
  const {
    conditionKey,
    conditionComparator,
  } = useSelector(pendingFilterSelector);

  const comparatorDataType = useSelector(selectedBaseConditionDataType) as DataTypeType;

  const handleChange = useCallback((value: ComparatorType) => {
    dispatch(modifyPendingFilter({ conditionComparator: value, conditionValue: undefined }));
  }, [dispatch]);

  const options = DATA_TYPE_TO_OPTIONS_MAP[comparatorDataType];

  useEffect(() => {
    if (!conditionComparator) {
      dispatch(modifyPendingFilter({ conditionComparator: options[0].value }));
    }
  }, [conditionComparator, dispatch, options]);

  return (
    <Select
      placeholder="Select a Comparision Condition"
      value={conditionComparator}
      onChange={handleChange}
      options={options as any}
      disabled={!conditionKey}
    />
  );
}
